import React from 'react';

import { PencilButton } from '../../../PencilButton';

export function EditButton(props: { onClick: () => void }) {
  return (
    <PencilButton
      onClick={() => props.onClick()}
      testIdPrefix="artist-fundraising-pick-"
      aria-label="edit artist fundraising pick"
    />
  );
}
